import React, { FC } from 'react';
import styles from './index.module.scss';
import { keepTwoOrLine } from '@/pages/IndustrialGreenMicBigScreen/utils';
import CustomTooltip from '@/pages/IndustrialGreenMicBigScreen/components/CustomTooltip';

interface ISVGDataBox {
  leftTitle: string;
  data: { label: string; value?: number | string; unit?: string; color?: string; wrapUnit?: boolean }[];
}

const SVGDataBox: FC<ISVGDataBox> = props => {
  const { leftTitle, data } = props;
  return (
    <div className={styles.yuan_box}>
      <div className={styles.left_top_bg}>{leftTitle}</div>
      {data.map((item, index) => (
        <div key={index} className={styles[`line${index}`]}>
          {item.wrapUnit ? (
            <>
              <div className={styles.wrap_first_line}>
                <div className={styles.label}>{item.label}</div>
                <CustomTooltip title={`${item.value}${item.unit}`}>
                  <div className={styles.wrap_value} style={{ color: item.color }}>
                    {item.value}
                  </div>
                </CustomTooltip>
              </div>
              <div className={styles.wrap_unit}>{item.unit}</div>
            </>
          ) : (
            <>
              <div className={styles.label}>{item.label}</div>
              <CustomTooltip title={`${item.value}${item.unit}`}>
                <div className={styles.value} style={{ color: item.color }}>
                  {item.value}
                  {item.unit}
                </div>
              </CustomTooltip>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default SVGDataBox;
